<template>
    <span
        class="tl-float-label"
        :class="{
            'tl-float-label-empty-label': !label
        }"
    >
        <slot />
        <label
            v-if="label"
            :id="`${id}-label`"
            :for="id"
        >{{ label }}</label>
    </span>
</template>

<script lang="ts" setup>
defineProps<{
    id: string
    label?: string
}>()
</script>

<style lang="sass" scoped>
@import './FloatLabel.sass'
</style>
